import { Translation } from '@ps/web-shared-components';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import { Message, TryAgainMessage } from '@swf/sports/components';
import EventStructuredData from '@swf/sports/components/EventStructuredData/EventStructuredData';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';
import useMarketUpdates from '@swf/sports/hooks/useMarketUpdates';

import { useSportsEventPageWidget } from '../../model';

import { TXTWCL_There_are_no_markets_available_ELL } from './Markets.messages.json';
import EventFinishedMessage from './components/EventFinishedMessage/EventFinishedMessage';
import EventNotFoundMessage from './components/EventNotFoundMessage/EventNotFoundMessage';
import MarketGroups from './components/MarketGroups/MarketGroups';

const Markets: React.FC = () => {
  const { widgetSelect, widgetDispatch } = useSportsEventPageWidget();
  const competition = useSelector(widgetSelect.competition);
  const marketIds = useSelector(widgetSelect.marketIds);
  const event = useSelector(widgetSelect.event);
  const eventType = useSelector(widgetSelect.eventType);
  const markets = useSelector(widgetSelect.markets);
  const errorCode = useSelector(widgetSelect.errorCode);
  const events = useSelector(widgetSelect.events);

  useMarketUpdates(marketIds, widgetDispatch.marketsUpdated);

  if (errorCode === 404) {
    return isEmpty(events) ? <EventNotFoundMessage /> : <EventFinishedMessage />;
  }

  if (typeof errorCode !== 'undefined') {
    return <TryAgainMessage />;
  }

  if (isEmpty(markets)) {
    return <Message message={<Translation {...TXTWCL_There_are_no_markets_available_ELL} />} />;
  }

  const [market] = Object.values(markets);

  return (
    <SportsComponent name="Sports Markets Component">
      <MarketGroups />
      {market && (
        <EventStructuredData
          event={event}
          eventType={eventType}
          market={market}
          competition={competition}
        />
      )}
    </SportsComponent>
  );
};

export default Markets;
